import { Dispatch } from 'redux'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { RootState } from "../../store/rootReducer"
import { apiInstance } from "../../api/apiInstance"
import anchor from '../../../constants/anchor'


const getShopInfo = () => async(
    dispatch: Dispatch,
    getState: () => RootState,
): Promise<void> => {
    const { userData } = getState()
    const params = {
        userId:  userData.smsAuth.userId,
    }
    const config = {
        headers: {
            Authorization: `${anchor} ${localStorage.getItem('accessToken')}`
        }
    }
    dispatch({ type: storeDispatchTypes.setSalesLoader, value: { field: 'shopInfo', value: true } })
    try {
        const { data: { status, data } } = await apiInstance.post('/sales/shop/getShopInfo', params, config)
        if(status === 'ok') {
            dispatch({
                type: storeDispatchTypes.setShopInfo,
                value: {
                    info: data
                },
            })
        }
    } catch (e) {
        console.error('get getShopInfo contact failed', e)
    }
    dispatch({ type: storeDispatchTypes.setSalesLoader, value: { field: 'shopInfo', value: false } })

}


export default getShopInfo
